<div class="not-found">
  <div class="container">
    <div class="not-found__header">
      <div class="not-found__label">
        {{'404'}}
      </div>
    </div>

    <div class="not-found__action">
      <span class="not-found__action__label">{{ 'The page you are looking for is not available' | translate }}</span>
      <button
        [routerLink]="['/']"
        class="mat-button button--white button-back">
        {{'Back to dashboard' | translate}}
      </button>
    </div>
  </div>
</div>
